import { Component, Input } from "@angular/core";

@Component({
  selector: "ngx-go-team-button",
  templateUrl: "go-team-button.component.html",
  styleUrls: ["go-team-button.component.scss"],
})
export class GoTeamButtonComponent {

  @Input() style: Record<string, string>;
  @Input() title: string = "Get more";
  @Input() source: string = '';
  @Input() primary: boolean = false;

  upgradeToTeam() {
    document.dispatchEvent(new CustomEvent('open-dialog', { detail: { id: 'upgrade-to-team', source: this.source } }));
  }
}
